import * as THREE from 'three';
import {
  BufferGeometry,
  Color,
  DoubleSide,
  Float32BufferAttribute,
  Mesh,
  MeshBasicMaterial,
  Uint16BufferAttribute,
  Vector3,
} from 'three';

import { renderOrders } from '../render-orders';

export class PickingFace extends Mesh {
  constructor(color?: THREE.Color) {
    const geometry = new BufferGeometry();
    geometry.setAttribute('position', new Float32BufferAttribute([0, 0, 0, 0, 0, 0, 0, 0, 0], 3));

    super(
      geometry,
      new MeshBasicMaterial({
        color: color ?? new Color(0, 1, 0),
        depthTest: false,
        depthWrite: false,
        side: DoubleSide,
        transparent: true,
        opacity: 0.35,
      }),
    );

    this.renderOrder = renderOrders.pickers.pickingFace;
  }

  updateVertex(index: number, point: Vector3) {
    this.geometry.attributes.position.setXYZ(index, point.x, point.y, point.z);

    this.geometry.attributes.position.needsUpdate = true;
    this.geometry.computeBoundingSphere();
    this.updateMatrix();
  }

  setNonIndexedVertices(vertices: Vector3[]) {
    this.geometry.setIndex(null);
    this.geometry.setAttribute(
      'position',
      new Float32BufferAttribute(vertices.map((x) => x.toArray()).flat(), 3),
    );
    this.geometry.computeBoundingSphere();
    this.updateMatrix();
  }

  setIndicesAndVertices(position: Float32BufferAttribute, indices: number[]) {
    this.geometry.setAttribute('position', position);
    this.geometry.setIndex(new Uint16BufferAttribute(indices, 1));

    this.geometry.attributes.position.needsUpdate = true;
    this.geometry.index!.needsUpdate = true;
    this.geometry.computeBoundingBox();
    this.geometry.computeBoundingSphere();
    this.updateMatrix();
  }

  setColor(color: THREE.Color) {
    (this.material as THREE.MeshBasicMaterial).color = color;
    (this.material as THREE.MeshBasicMaterial).needsUpdate = true;
  }
}
